<template>

  <div class="row">
    <div class="col-6 card col-laptop-12">
      <div class="row justify-content-space-between">
        <strong class="col-11 card-title"><span class="icon-Bookmark"></span>Услуги</strong>
        <!-- <div class="right col-3 align-self-end"><button class="btn-circle"><span class="icon-Plus" style="top: -1px; left: -1px"></span></button></div> -->
      </div>
      <div class="row ">
        <!-- <div class="col-12">
          <small>Пакетовскрыватель:</small><br>
          <strong>Пакетовскрыватель 1</strong>
        </div> -->
        <div class="col-12">
          <small>Остаток на счёте:</small><br>
          <strong v-if="Contracts">{{ ContractsAmount }} руб. </strong>
          <strong v-else>Загрузка...</strong>
          <br>

        </div>
        <div class="col-12">
          <div class="text-field">
            <label class="text-field__label" for="search">Наименование договора</label>
            <div class="row">
              <div class="col-12 text-field__icon">
                <input class="text-field__input" type="search" name="search" id="search"  disabled="True" value="Приём отходов в тоннах">
                
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="row top-24">
        <router-link to="/polygon/contracts" class="col-12 btn-primary"><span class="icon-DownloadSimple"></span>Все договоры</router-link>
      </div>
    </div>
    
    <!-- <div class="col-4 card col-laptop-12">
      <div class="row justify-content-space-between">
        <strong class="col-11 card-title"><span class="icon-Lifebuoy"></span>Календарь событий</strong>
      </div>
      <div class="row ">
        <div class="col-12" style="text-align: center;">
          <date-picker class="btn-tab btn-tab-active right-space-16" v-model:value="datefilter" inline auto-apply></date-picker>
        </div>
      </div>
    </div> -->

    <div class="col-6 card col-laptop-12">
      <div class="row justify-content-space-between">
        <strong class="col-7 card-title"><span class="icon-ArrowRight"></span>Запланировано</strong>
      </div>
      <div class="row">

        <table width="100%" v-if="Events.Order">

          <tbody>
            <tr class="bottom" v-for="order in Events.Order">
                <td >
                  <small>Заявка {{ order.OrderID }} </small><br>
                  <small class="gray"> {{ order.OrderCar }}</small> - 
                  <small class="gray"> {{ order.OrderDriver }}</small>
                </td>
                <td style="text-align: center;">
                  <small class="green" style="position: relative;">{{ format_date(order.OrderDate) }}</small>
                </td>
            </tr>
            
          </tbody>
        </table>
        <div class="col-12" v-else>
          {{ Events['answer'] }}
        </div>
      </div>
      <!-- <div class="row top-24">
        <button class="col-6 btn-primary"><span class="icon-DownloadSimple"></span></button>
        <button class="col-6 btn-secondary" @click="clickCam('192.168.178.147')"><span class="icon-Camera"></span>Камера</button>
      </div> -->
      <div class="row top-24">
        <router-link to="/polygon/new_order" class="col-12 btn-primary"><span class="icon-Plus"></span>Добавить рейс</router-link>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-8 card col-laptop-12">
      <div class="row justify-content-space-between">
        <strong class="col-5 card-title">Вес отгрузки по дням 
          <br><small v-if="this.datefilter[0]">c {{ format_date(this.datefilter[0], 'date') }} по {{ format_date(this.datefilter[1], 'date') }}</small>
        </strong>
      </div>
      <div class="col-12">
        <!-- <date-picker class="btn-tab btn-tab-active right-space-16" v-model:value="datefilter" range></date-picker> -->
        <div>
          <table width="100%" v-if="Orders.Orders">
            <thead>
            <tr>
              <th scope="col">Выгрузка на полигон</th>
              <th scope="col">Вес (кг)</th>
            </tr>
            </thead>
            <tbody>
              <tr class="bottom" v-for="(date, index) in getOrderDates"
                :key="index"
                >
                  <td >
                    {{ date }}
                  </td>
                  <td style="text-align: center;">
                      {{ Change(weights(date)) }}
                  </td>
              </tr>
            </tbody>
          </table>
          <div v-else-if="Orders['answer']">
            {{ Orders['answer'] }}
          </div>
          <div v-else>
            Идёт загрузка...
          </div>
          <!-- <DashChart v-if="Orders"
            :dates="getOrderDates" 
            :results="resultQuery"
            :report_title="'Отгрузки на полигон'" 
            :first_answer_result="'нет'" 
            :second_answer_result="''">
          </DashChart> -->
        </div>
      </div>
    </div>
    <div class="col-4 card col-laptop-12">
      <div class="row justify-content-space-between">
        <strong class="col-8 card-title">История рейсов</strong>
      </div>
        
        <div class="col-12">
          <div style="overflow: auto; height: 500px;" v-if="Orders.Orders">
            <table width="100%" >
              
              <tbody >
                <tr class="bottom" v-for="order in SortedOrders">
                    <td >
                      <small>Рейс по заявке {{ order.OrderID }} от {{ format_date(order.OrderDate) }}</small><br>
                      <small class="gray"> {{ order.OrderCar }}</small>
                    </td>
                    <td style="text-align: center;">
                      <!-- <small class="red" style="position: relative;">Стоимость 1 000 р.</small><br> -->
                      <small class="green" style="position: relative;">Вес {{ Change(order.OrderWeight) }} кг</small>
                    </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else-if="Orders['answer']">
            {{ Orders['answer'] }}
          </div>
          <div v-else>
            Идёт загрузка...
          </div>
          <div class="row top-24">
            <router-link to="/polygon/history" class="col-12 btn-primary"><span class="icon-DownloadSimple"></span>Подробнее</router-link>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import byBatchs from "@/components/Dashbord/HomeFactory/byBatchs.vue";
import byTotal from "@/components/Dashbord/HomeFactory/byTotal.vue";
// import VueSpeedometer from "vue-speedometer"
import DashChart from "@/components/Dashbord/DashChart.vue";
import ProgressBar from "@/components/Shared/ProgressBar.vue";
import moment from 'moment'

export default {
  components: { DashChart, ProgressBar },
  data() {
    return {
      datefilter: [this.week_ago(), this.today_date()],
       styles: {
        padding: "15px",
        height: "150px",
      },
      
      showSearch: false,
      title: "Дашборд",

      options: {

        chart: {
          id: 'vuechart-example'
        },
        stroke: {
          curve: 'smooth',
          colors: ['#F26650', '#000000'],
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          colors: ['#F26650', '#000000'],
          type: 'solid',
          opacity: 0.1,
        },
        xaxis: {
          categories: [20, 21, 22, 23, 24, 25, 26]
        }
      },

      series: [
        {
          name: 'Руб.',
          color: '#F26650',
          data: [20, 0, 5, 18, 0, 20, 0]
        },
    ]
    }
  },
  beforeMount() { document.title = this.title },
  mounted() {
    // this.$store.dispatch("fetchPolygonContracts", this.currentUser.company_inn);
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    Contracts() {
      return this.$store.state.polygon_company.Contracts
    },
    ContractsAmount() {
      return this.Change(this.$store.state.polygon_company.Contracts.reduce((acc, item) => acc + item['Amount'], 0))
    },
    Orders() {
            return this.$store.state.polygon_orders
    },
    SortedOrders() {
      return this.$store.state.polygon_orders.Orders.sort((a, b) => new Date(b.OrderDate) - new Date(a.OrderDate))
        // return this.$store.state.polygon_orders.Orders.sort((a, b) => new Date(b.OrderDate) - new Date(a.OrderDate)).slice(0, 10)
    },
    getOrderDates() {
      const dates = new Set();
      this.$store.state.polygon_orders.Orders.forEach(item => dates.add(item.OrderDate.split('T')[0]))
      return Array.from(dates); 
    },
    Events() {
            return this.$store.state.polygon_events
    },
  },
  methods: {

    format_date(value, time='NaN'){
      if (value) {
        if (time != 'NaN') {
          return moment(String(value)).format('DD.MM.YYYY')
        } else {
          return moment(String(value)).format('DD.MM.YYYY HH:mm')
        }
      }
    },
    today_date(){
      const today = new Date();

      return moment(String(today)).format('YYYY-MM-DD')
      
    },
    week_ago(){
      const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);

      return moment(String(sevenDaysAgo)).format('YYYY-MM-DD')
    },
    Change(number) {
      number = Math.trunc(number)
      return number.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')
    },
    weights(date) {
      let sum_array = this.$store.state.polygon_orders.Orders
          .filter(item => item.OrderDate.split('T')[0] === date)
          .map(item => parseInt(item.OrderWeight));
      return sum_array.reduce(function(sum_array, num){ return sum_array + num }, 0)
    },
  },
  created() {
    this.$store.dispatch("fetchPolygonContracts", this.currentUser.company_inn);
    this.$store.dispatch("fetchPolygonOrders", { inn: this.currentUser.company_inn, start_date: this.week_ago(), end_date: this.today_date() });
    this.$store.dispatch("fetchPolygonEvents", this.currentUser.company_inn);
  },
  beforeUnmount () {

  }


};
</script>
